import React, { useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Import Components
import Header from './components/Header';
import Hero from './components/Hero';
import BookShowcase from './components/BookShowcase';
import PurchasePlatforms from './components/PurchasePlatforms';
import PodcastSection from './components/PodcastSection';
import TeamSection from './components/TeamSection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

// Import CSS
import './App.css';

function App() {
  // Create refs for each section we want to scroll to
  const homeRef = useRef(null);
  const booksRef = useRef(null);
  const podcastRef = useRef(null);
  const aboutRef = useRef(null);
  const reviewsRef = useRef(null);

  // Create sections data to pass to Header
  const sections = [
    { id: 'home', ref: homeRef, label: 'HOME' },
    { id: 'books', ref: booksRef, label: 'BOOKS' },
    { id: 'podcast', ref: podcastRef, label: 'PODCAST' },
    { id: 'about', ref: aboutRef, label: 'ABOUT' },
    { id: 'reviews', ref: reviewsRef, label: 'REVIEWS' }
  ];

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-[#0a0a1a]">
        <Header sections={sections} />
        <main className="flex-grow">
          {/* Home Section */}
          <section ref={homeRef} id="home" className="relative">
            <Hero />
          </section>

          {/* Books Section */}
          <section ref={booksRef} id="books" className="relative">
            <BookShowcase />
            <PurchasePlatforms />
          </section>

          {/* Podcast Section */}
          <section ref={podcastRef} id="podcast" className="relative">
            <PodcastSection />
          </section>

          {/* About Section */}
          <section ref={aboutRef} id="about" className="relative">
            <TeamSection />
          </section>

          {/* Reviews Section */}
          <section ref={reviewsRef} id="reviews" className="relative">
            <Testimonials />
          </section>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
